import { render, staticRenderFns } from "./UserMessage.vue?vue&type=template&id=46c3b985&scoped=true&"
import script from "./UserMessage.vue?vue&type=script&setup=true&lang=js&"
export * from "./UserMessage.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./UserMessage.vue?vue&type=style&index=0&id=46c3b985&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.10.2_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17._qkvgvrmvpkafkn37suro37nope/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c3b985",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/web_gys_admin_online_docker/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46c3b985')) {
      api.createRecord('46c3b985', component.options)
    } else {
      api.reload('46c3b985', component.options)
    }
    module.hot.accept("./UserMessage.vue?vue&type=template&id=46c3b985&scoped=true&", function () {
      api.rerender('46c3b985', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/nb/order/components/orderDetail/UserMessage.vue"
export default component.exports